<nb-tabset>
    <nb-tab tabTitle="Reportes Internos" tabIcon="pie-chart-outline" responsive>
        <iframe class="dataStudioReport"
            src="https://datastudio.google.com/embed/reporting/be8e9e93-7c21-4adb-b73e-004146e8ac79" frameborder="0"
            width="1000" height="400"></iframe>
    </nb-tab>
</nb-tabset>